import Wave from "./Wave";
function About() {
    return (
        <div className="aboutContainer" id="about">
            <div className="aboutContent">
                <div className="aboutContentContainer">
                    <h1 className="aboutTitle">About Us</h1>
                    <p className="aboutSubtitle">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi optio nam reprehenderit ea corrupti voluptates, eveniet quo saepe deserunt ipsa laborum aliquid adipisci recusandae at libero corporis, et blanditiis? Vel, pariatur! Ipsum consectetur quo, esse quidem suscipit omnis perspiciatis, harum commodi assumenda dolorem quae repellendus dolore corporis, molestiae nesciunt magnam.
                    </p>
                </div>
            </div>
            <div className="rightImgContainer">
                <div className="imageContainer">
                    <div className="imageBackground"></div>
                    <img className="aboutImage" src="/images/about-img.png" alt="About Us"/>
                </div>
            </div>
            <Wave></Wave>
        </div>
    );
}
export default About;